module.exports = __webpack_public_path__ + "static/media/TN-Women-Tops.db03bf36.svg";